module.exports = __webpack_public_path__ + "img/Silver.ae2e1800.png";